import React from "react";
import { Navigate } from "react-router-dom";
import { getStoredUser } from "../utils/authStorage";

const ProtectedRoute = ({ children }) => {
  const user = getStoredUser();

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
